module.exports = {
  /* 01.General */
  "chat.end":"Перезапустите чат",
  "chat.endall":"Конец чат",
  "chat.cancel":"Отмена",
  "chat.cookie":"Этот цифровой помощник использует файлы cookie, чтобы обеспечить вам наилучшие впечатления.",
  "chat.learn":"Учить больше",
  "chat.minimize":"Свести к минимуму",
  "chat.hide":"Закрывать",
  "chat.hidebot.text":"Close заставит аватар исчезнуть на 15 минут.",
  "chat.hidebot":"Закрыть (скрыть) аватар",
  "chat.restart":"Начать сначала",
  "switch.language":"Смена языка",
  "switch.property":"Переключить свойство",
  "restart.converstation":"Перезапустить разговор",
  "chat.endtext":"Вы уверены, что хотите завершить текущий чат?",
  "check.availabity":"Проверить наличие свободных мест",
  "check.availabity.submit":"Представлять на рассмотрение",
  "check.availabity.cancel":"Отмена",
  "check.availabity.adults":"Взрослые ",
  "check.availabity.children":"Дети",
  "check.availabity.child.age":"Возраст - ребенок",
  "feedback.leave":"Оставьте отзыв",
  "feedback.leave.message":"Оставить сообщение",
    "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email" :" Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode":"Zip Code"
};
